import React, { useCallback, useState } from 'react';
import { Button, Container, Col, Row } from 'reactstrap';
import ReactMarkdown from 'lib/react-markdown';
import Modal from '../Modal';
import classNames from 'classnames';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faInfoCircle } from '@fortawesome/pro-light-svg-icons/faInfoCircle';

function SpeakerInfo({
  cols = 'col-12 col-md-4 col-lg-3',
  id,
  modalLink,
  name,
  shortName,
  presentation,
  description,
  image,
  bio,
  ...props
}) {
  const [isOpen, setIsOpen] = useState(false); // The parameter (false) is the default value
  const onClick = useCallback(() => setIsOpen(true), []);
  // A function is used in the below callback to get the latest value of isOpen, useCallback "memoizes"
  // the function which increases performance but could cause data to be out of date.
  const toggle = useCallback(() => setIsOpen(isOpen => !isOpen), []); //
  return (
    <Col className={classNames(`speaker-info speaker-${id}`, cols)}>
      <Row className="speaker-info-row">
        <Col xs="12" className="speaker-info-col">
          <div className="speaker-info-wrap">
            <div className="speaker-info-image mb-md-2">
              {!modalLink ? (
                <Button className="speaker-list-item-link" color="img" onClick={onClick}>
                  <img className="speaker-headshot img-fluid img-speaker-shadow center-block rounded" src={image} />
                </Button>
              ) : (
                <div className="speaker-list-item-image">
                  <img className="speaker-headshot img-fluid img-speaker-shadow center-block rounded" src={image} />
                </div>
              )}
            </div>
            {props.teaser ? (
              <div className="speaker-info-details mb-auto">
                <p className="speaker-name text-700 mt-md-2 mb-2 balance-text">{name}</p>
                {props.noTitle ? null : (
                  <p className="speaker-presentation balance-text text-small mb-3">
                    <i>{presentation}</i>
                  </p>
                )}
                <p className="speaker-teaser text-small balance-text mb-2">{description}</p>
              </div>
            ) : (
              <div className="speaker-info-details my-auto">
                <p className="speaker-name text-700 mb-0">{name}</p>
                {props.noTitle ? null : (
                  <p className="speaker-presentation balance-text text-small mb-0">{presentation}</p>
                )}
              </div>
            )}
            {!modalLink ? (
              <div className="speaker-info-more">
                <div className="mt-md-2 mb-0">
                  <Button className="speaker-info-btn" color="speaker-info" onClick={onClick} block>
                    <FontAwesomeIcon className="speaker-info-btn-icon d-md-none" icon={faInfoCircle} />
                    <span className="d-none d-md-inline">Learn&nbsp;</span>
                    More
                  </Button>
                </div>
                <Modal isOpen={isOpen} toggle={toggle} size="lg" className={props.modalClass}>
                  <Container className="px-sm-4 pt-0 pb-4" fluid>
                    <Row className="d-flex align-items-center justify-content-center mb-4">
                      <Col xs="10" lg="4" className="mb-4 mb-lg-0">
                        <LazyLoad height={245} offset={100}>
                          <img
                            className="speaker-headshot img-fluid img-speaker-shadow center-block rounded-circle"
                            src={image}
                          />
                        </LazyLoad>
                      </Col>
                      <Col xs="12" lg="8">
                        <div className="speaker-details">
                          <h3 className="speaker-name section-heading mb-2">{name}</h3>
                          <h5 className="speaker-presentation mt-0">{presentation}</h5>
                          <p className="speaker-description mb-0">{description}</p>
                        </div>
                      </Col>
                    </Row>
                    <Row>
                      <Col xs="12">
                        <div className="speaker-bio-info">
                          <h5 className="speaker-bio-heading section-heading">More About {shortName}</h5>
                          <ReactMarkdown source={bio || ''} />
                        </div>
                      </Col>
                    </Row>
                  </Container>
                </Modal>
              </div>
            ) : null}
          </div>
        </Col>
      </Row>
    </Col>
  );
}

export function SpeakerListInfo({ speakerList = speakers, ...props }) {
  // Very basic, usually (but not always!) in the order of the JSON file
  return speakerList.map(speaker => <SpeakerInfo {...speaker} key={speaker.id} {...props} />);
}
